import { Navigate } from 'react-router-dom';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import WysiwygIcon from '@mui/icons-material/Wysiwyg';
import SignInPage from 'pages/SignInPage';
import SignUpPage from 'pages/SignUpPage';
import ForgotPassPage from 'pages/ForgotPassPage';
import Dashboard from 'pages/Dashboard';
import Settings from 'pages/Settings';
import Jobs from 'pages/Jobs';
import ForgotPassword from 'pages/ForgotPassPage/components/ForgotPassword';
import ResetPassword from 'pages/ForgotPassPage/components/ResetPassword';
import ChangePassword from 'pages/ForgotPassPage/components/ChangePassword';
import PrivateRoute from 'pages/PrivateRoute';

import GraphicIcon from 'assets/svg/GraphicIcon';
import { ViewKanban, Mail, EventRepeat, Feedback, FeedbackRounded } from '@mui/icons-material';
import UserActivity from 'pages/UserActivity/UserActivity';
import ConversationExplorer from 'pages/ConversationExplorer/ConversationExplorer';
import MessageScheduler from 'pages/MessageScheduler/MessageScheduler';
import Prompts from 'pages/Prompts/Prompts';
import Feedbacks from 'pages/Feedbacks/Feedbacks';

export enum PathENUM {
  DASHBOARD = '/',
  SIGN_IN = '/sign-in',
  SIGN_UP = '/sign-up',
  FORGOT_PASSWORD = '/forgot-password',
  RESET_PASSWORD = 'reset-password',
  CHANGE_PASSWORD = 'change-password',
  JOBS = '/jobs',
  SETTINGS = '/settings',
  USER_ACTIVITY = '/user-activity',
  CONVERSATION_EXPLORER = '/conversation-explorer',
  MESSAGE_SCHEDULER = '/message-scheduler',
  PROMPTS = '/prompts',
  FEEDBACKS = '/feedbacks',
  ANY = '*',
}

export const navigateMenuPathsArray = [
  // {
  //   path: PathENUM.DASHBOARD,
  //   Icon: GraphicIcon,
  //   title: 'Dashboard',
  // },
  {
    path: PathENUM.USER_ACTIVITY,
    Icon: ViewKanban,
    title: 'User activity',
  },
  {
    path: PathENUM.CONVERSATION_EXPLORER,
    Icon: Mail,
    title: 'Conversation explorer',
  },
  {
    path: PathENUM.MESSAGE_SCHEDULER,
    Icon: EventRepeat,
    title: 'Message Scheduler',
  },
  {
    path: PathENUM.PROMPTS,
    Icon: WysiwygIcon,
    title: 'Prompts',
  },
  {
    path: PathENUM.FEEDBACKS,
    Icon: FeedbackRounded,
    title: 'Feedbacks',
  },
  // {
  //   path: PathENUM.JOBS,
  //   Icon: WorkIcon,
  //   title: 'All jobs',
  // },
  {
    path: PathENUM.SETTINGS,
    Icon: AccountCircleIcon,
    title: 'Settings',
  },
];

export const arrRoutes = [
  {
    path: PathENUM.DASHBOARD,
    element:
      <Navigate to={PathENUM.USER_ACTIVITY} replace />,
  },
  {
    path: PathENUM.SIGN_IN,
    element:
      <PrivateRoute isNeedAuth={false}>
        <SignInPage />
      </PrivateRoute>,
  },
  {
    path: PathENUM.SIGN_UP,
    element:
      <PrivateRoute isNeedAuth={false}>
        <SignUpPage />
      </PrivateRoute>,
  },
  {
    path: PathENUM.FORGOT_PASSWORD,
    element:
      <PrivateRoute isNeedAuth={false}>
        <ForgotPassPage />
      </PrivateRoute>,
    children: [
      {
        path: '',
        element:
            <ForgotPassword />,
      },
      {
        path: PathENUM.RESET_PASSWORD,
        element:
            <ResetPassword />,
      },
      {
        path: PathENUM.CHANGE_PASSWORD,
        element:
            <ChangePassword />,
      },
    ],
  },
  // {
  //   path: PathENUM.JOBS,
  //   element:
  //     <PrivateRoute isNeedAuth>
  //       <Jobs />
  //     </PrivateRoute>,
  // },
  {
    path: PathENUM.SETTINGS,
    element:
      <PrivateRoute isNeedAuth>
        <Settings />
      </PrivateRoute>,
  },
  {
    path: PathENUM.USER_ACTIVITY,
    element:
      <PrivateRoute isNeedAuth>
        <UserActivity />
      </PrivateRoute>,
  },
  {
    path: PathENUM.CONVERSATION_EXPLORER,
    element:
      <PrivateRoute isNeedAuth>
        <ConversationExplorer />
      </PrivateRoute>,
  },
  {
    path: PathENUM.MESSAGE_SCHEDULER,
    element:
      <PrivateRoute isNeedAuth>
        <MessageScheduler />
      </PrivateRoute>,
  },
  {
    path: PathENUM.PROMPTS,
    element:
      <PrivateRoute isNeedAuth>
        <Prompts />
      </PrivateRoute>,
  },
  {
    path: PathENUM.FEEDBACKS,
    element:
      <PrivateRoute isNeedAuth>
        <Feedbacks />
      </PrivateRoute>,
  },
  {
    path: PathENUM.ANY,
    element:
      <Navigate to={PathENUM.DASHBOARD} replace />,
  },
];
